module.exports = __webpack_public_path__ + "img/sbzc_22.e68daeb2.jpg";